<script setup lang="ts">
// useI18n (not $t globals): this page is MF-exposed via ./routes — explicit
// import keeps it type-checkable standalone (MF DTS compiles exposed files
// out of app context, where global-property augmentation isn't loaded).
import { inject } from "vue";
import { useI18n } from "vue-i18n";
// Relative (not @/) import: reachable from the ./routes expose, whose emitted
// d.ts ships to consumers where the producer's @/ alias can't resolve.
import { NAV_TOGGLE_KEY, type NavToggleComponent } from "../../features/layout/nav-toggle";
import styles from "./HomePage.module.css";

const { t } = useI18n();

// Provided by PageFrame. Null when this page renders outside a frame that
// supplies one — render nothing rather than break.
const navToggle = inject<NavToggleComponent | null>(NAV_TOGGLE_KEY, null);
</script>

<template>
  <main :class="styles.page">
    <header :class="styles.header">
      <div v-if="navToggle" :class="styles.headerToggle">
        <component :is="navToggle" />
      </div>
      <div :class="styles.headerContent">
        <h1 :class="styles.title">{{ t("home.title") }}</h1>
      </div>
    </header>

    <section :class="styles.content">
      <p>{{ t("home.welcome") }}</p>
    </section>
  </main>
</template>
